<app-auth-container [page]="registrationPage"></app-auth-container>
